import { Util } from '@grandvisionhq/forms';
import { useIntl } from '@grandvisionhq/state';

// Some data, like billing address and shipping contact, are only available after the user authorized the payment.
const isEmailValid = (email)=>email && Util.validations.isEmailAddress(email)
;
const isPostalCodeValid = (country, postalCode)=>country && postalCode && Util.validations.isValidPostalCodeForCountry(country, postalCode)
;
const useValidatePaymentData = ()=>{
    const { getLabel  } = useIntl();
    return (e, session)=>{
        const { shippingContact , billingContact  } = e === null || e === void 0 ? void 0 : e.payment;
        if (!isEmailValid(shippingContact === null || shippingContact === void 0 ? void 0 : shippingContact.emailAddress)) {
            session.completePayment({
                status: ApplePaySession.STATUS_INVALID_SHIPPING_CONTACT,
                errors: [
                    new ApplePayError('shippingContactInvalid', 'emailAddress', getLabel('checkout.contact.email.errorMessage')), 
                ]
            });
            return false;
        }
        if (!isPostalCodeValid(billingContact === null || billingContact === void 0 ? void 0 : billingContact.countryCode, billingContact === null || billingContact === void 0 ? void 0 : billingContact.postalCode)) {
            session.completePayment({
                status: ApplePaySession.STATUS_INVALID_BILLING_POSTAL_ADDRESS,
                errors: [
                    new ApplePayError('billingContactInvalid', 'postalCode', getLabel('checkout.address.postalCode.errorMessage')), 
                ]
            });
            return false;
        }
        if (!isPostalCodeValid(shippingContact === null || shippingContact === void 0 ? void 0 : shippingContact.countryCode, shippingContact === null || shippingContact === void 0 ? void 0 : shippingContact.postalCode)) {
            session.completePayment({
                status: ApplePaySession.STATUS_INVALID_SHIPPING_POSTAL_ADDRESS,
                errors: [
                    new ApplePayError('shippingContactInvalid', 'postalCode', getLabel('checkout.address.postalCode.errorMessage')), 
                ]
            });
            return false;
        }
        if (!(billingContact === null || billingContact === void 0 ? void 0 : billingContact.locality)) {
            session.completePayment({
                status: ApplePaySession.STATUS_INVALID_BILLING_POSTAL_ADDRESS,
                errors: [
                    new ApplePayError('billingContactInvalid', 'locality', getLabel('checkout.address.city.errorMessage')), 
                ]
            });
            return false;
        }
        if (!(billingContact === null || billingContact === void 0 ? void 0 : billingContact.phoneNumber)) {
            session.completePayment({
                status: ApplePaySession.STATUS_INVALID_BILLING_POSTAL_ADDRESS,
                errors: [
                    new ApplePayError('billingContactInvalid', 'phoneNumber', getLabel('checkout.contact.phoneNumber.errorMessage')), 
                ]
            });
            return false;
        }
        return true;
    };
};

export { useValidatePaymentData };
//# sourceMappingURL=use-validate-payment-data.js.map
